import script from "./OrderManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderManagement.vue?vue&type=script&setup=true&lang=js"

import "./OrderManagement.vue?vue&type=style&index=0&id=3a5424c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a5424c8"]])

export default __exports__